import { JaneDetailsModalComponentMap } from './JaneDetailsModal.constants';
import { JaneDetailsModalViewType } from './JaneDetailsModal.constants';

import { useURLParameters } from 'hooks';
import { createContext, FC, useContext, useEffect } from 'react';
import { PAGE_URLS } from 'components/BKJMainNavigation/BKJMainNavigation.constants';
import { useLocation } from 'react-router-dom';

export interface IJaneDetailsModalUI {
  isOpen: boolean;
  janeId?: string;
  janeDetailsModalActiveModalView: JaneDetailsModalViewType;
  isEditablePage: boolean;
}

export const JaneDetailsModalUIContext = createContext<IJaneDetailsModalUI>({
  isOpen: false,
  janeId: undefined as IJaneDetailsModalUI['janeId'],
  janeDetailsModalActiveModalView: 'JaneDetailsView' as JaneDetailsModalViewType,
  isEditablePage: false,
});

export const JaneDetailsModalUIProvider: FC = ({ children }) => {
  const [{ janeId: janeDetailsModalJaneId, janeDetailsModalActiveModalView }, { removeParam }] =
    useURLParameters<{
      janeDetailsModalJaneId?: string;
      janeDetailsModalActiveModalView: JaneDetailsModalViewType;
    }>();

  const { pathname } = useLocation();

  const janeId = janeDetailsModalJaneId ? janeDetailsModalJaneId : undefined;
  useEffect(() => {
    if (!Object.keys(JaneDetailsModalComponentMap).includes(janeDetailsModalActiveModalView)) {
      removeParam(['janeDetailsModalActiveModalView', 'janeDetailsModalJaneId']);
    }
    if (!janeId && janeDetailsModalActiveModalView) {
      removeParam('janeDetailsModalActiveModalView');
    }
  }, [removeParam, janeDetailsModalActiveModalView, janeId]);

  // Pages where we allow showing the Edit button on the jane modal
  const isEditablePage = pathname.startsWith(PAGE_URLS.TEAM_MEMBER);

  return (
    <JaneDetailsModalUIContext.Provider
      value={{
        isOpen: !!janeDetailsModalActiveModalView,
        janeDetailsModalActiveModalView,
        janeId,
        isEditablePage,
      }}
    >
      {children}
    </JaneDetailsModalUIContext.Provider>
  );
};

export const useJaneDetailsModalUIContext = () => useContext(JaneDetailsModalUIContext);
